import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogSurface,
    DialogTitle,
    DialogTrigger
} from "@fluentui/react-components";

function ConfirmDialog({ title, description, buttonText, onConfirm, buttonColor, appearance = "primary", altButtonText = null, className = "", buttonSize = `medium`, altButton = null}) {
    return (
        <Dialog>
            <DialogTrigger>
                <div style={{display: "flex"}}>
                    { altButton ? altButton : <Button as={"a"} appearance={appearance} className={`button ${className}`} size={buttonSize}>{altButtonText ? altButtonText : buttonText}</Button> }
                </div>
            </DialogTrigger>
            <DialogSurface className={`dialog`}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <div className={`dialog-content-container`}>
                        {description}
                    </div>
                </DialogContent>
                <DialogActions>
                    <DialogTrigger disableButtonEnhancement>
                        <Button as={"a"} className={`button`} appearance="secondary">Annuleren</Button>
                    </DialogTrigger>
                    <DialogTrigger>
                        <Button as={"a"} className={`button`} appearance="primary" style={{backgroundColor: buttonColor}} onClick={onConfirm}>
                            {buttonText}
                        </Button>
                    </DialogTrigger>
                </DialogActions>
            </DialogSurface>
        </Dialog>
    );
}

export default ConfirmDialog;